import { Draggable, Eventcalendar, setOptions } from '@mobiscroll/react';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import {
  Datepicker,
  formatDate,
  Input,
  Popup,
  Snackbar
} from '@mobiscroll/react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import CommentIcon from '@mui/icons-material/Comment';
import Delete from '@mui/icons-material/Delete';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import SaveIcon from '@mui/icons-material/Save';
import WarningIcon from '@mui/icons-material/Warning';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CardHeader, Checkbox, Divider, Grid, IconButton, Modal, Stack, Tooltip, Typography } from "@mui/material";
import { guid } from '@progress/kendo-react-common';
import { DropDownList, } from '@progress/kendo-react-dropdowns';
import { NumericTextBox } from "@progress/kendo-react-inputs";
import moment from 'moment';
import DatePicker from "react-datepicker";
import AlertComponent from "../../../../shared/common-utilities/common/AlertComponent.jsx";
import ToggleMenuForConfig from '../../../../shared/common-utilities/common/toggleMenuForConfig/toggleMenuForConfig.jsx';
import MountedForklift from '../../../../shared/common-utilities/Qualifications/MountedForklift.jsx';
import OpenRoof from '../../../../shared/common-utilities/Qualifications/OpenRoof.jsx';
import RoalerBed from '../../../../shared/common-utilities/Qualifications/RoalerBed.jsx';
import TailLift from '../../../../shared/common-utilities/Qualifications/TailLift.jsx';
import TemperatureHigh from '../../../../shared/common-utilities/Qualifications/TemperatureHigh.jsx';
import BoxTrailer from '../../../../shared/common-utilities/Trailer/BoxTrailer.jsx';
import Semitrailer2 from '../../../../shared/common-utilities/Trailer/Semitrailer2.jsx';
import TankTrailer from '../../../../shared/common-utilities/Trailer/TankTrailer.jsx';
import BoxedTruck12Ton2Axles from '../../../../shared/common-utilities/Truck/BoxedTruck12Ton2Axles.jsx';
import EuropeanTruck from '../../../../shared/common-utilities/Truck/EuropeanTruck.jsx';
import ContainerIcon from '../../../../shared/common-utilities/utils/ContainerIcon.jsx';
import ContainerIconWh from '../../../../shared/common-utilities/utils/ContainerIconWh.jsx';
import IconTruck from '../../../../shared/common-utilities/utils/IconTruck.jsx';
import IconTruckWh from '../../../../shared/common-utilities/utils/IconTruckWh.jsx';
import TrailerBlIcon from '../../../../shared/common-utilities/utils/TrailerBlIcon.jsx';
import TrailerIcon from '../../../../shared/common-utilities/utils/TrailerIcon.jsx';
import VariousResourceBlIcon from '../../../../shared/common-utilities/utils/VariousResourceBlIcon.jsx';
import { drageItemsReducer } from "../../../../shared/ReduxStore/Reducers/dragReducer";
// import { setSchedulerTrayReducer } from "../../../../shared/ReduxStore/Reducers/schedulerTrayReducer.jsx";
import ContextMenu from "../ContextMenu/ContextMenu";
import ChassisTrailer from './../../../../shared/common-utilities/Trailer/ChassisTrailer';
import FlatbedTruck from './../../../../shared/common-utilities/Truck/FlatbedTruck';
import CustomAgendaTooltip from './CustomAgendaTooltip';
import CustomScheduleEvent from './CustomScheduleEvent';
import { BREAK, CLEANING, COUPLE, DEPOSIT, DRIVE, FERRYOF, FERRYON, LOAD, LOADDEPOT, msDriverResourceData, msEventData, msTrailerResourceData, msTruckResourceData, PICKUP, UNCOUPLE, UNLOAD, UNLOADDEPOT } from './data.js';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { process } from '@progress/kendo-data-query';
setOptions({
  theme: 'ios',
  themeVariant: 'light'
});

function Task({ data }) {
  const [draggable, setDraggable] = useState();

  const eventLength = Math.round(Math.abs(new Date(data.end).getTime() - new Date(data.start).getTime()) / (60 * 60 * 1000));

  return (
    <div>
      {!data.hide && (
        <div ref={setDraggable} className="external-drop-task" style={{ background: data.color }}>
          <div>{data.title}</div>
          <div>{eventLength + ' hour' + (eventLength > 1 ? 's' : '')}</div>
          <Draggable dragData={data} element={draggable} />
        </div>
      )}
    </div>
  );
}

Task.propTypes = {
  data: PropTypes.object.isRequired,
};
const colors = ['#ffeb3c', '#ff9900', '#f44437', '#ea1e63', '#9c26b0', '#3f51b5', '', '#009788', '#4baf4f', '#7e5d4e'];
const vhColor = "#64c6bb"
const scColor = "#afdcae"
const trColor = "#64c6bb"
function AgendaDemoMs() {
  const now = new Date();


  var tommorow = new Date();
  tommorow.setDate(tommorow.getDate() + 1)
  const [dropCont, setDropCont] = useState();
  const [isToastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState();
  const [myEvents, setMyEvents] = useState(
    msEventData
  );
  const [myTasks, setTasks] = useState([
    {
      id: 1,
      title: 'Product team meeting',
      color: '#cf4343',
      start: '2024-03-12T08:00',
      end: '2024-03-12T09:30',
    },
    {
      id: 2,
      title: 'General orientation',
      color: '#e49516',
      start: '2024-03-12T08:00',
      end: '2024-03-12T10:00',
    },
    {
      id: 3,
      title: 'Client Training',
      color: '#8c429f',
      start: '2024-03-12T10:00',
      end: '2024-03-12T14:00',
    },
    {
      id: 4,
      title: 'CEO Conference',
      color: '#63b548',
      start: '2024-03-12T12:00',
      end: '2024-03-12T18:00',
    },
  ]);
  const [myResources, setMyResources] = useState(
    msTruckResourceData
  )
  const [myColors, setMyColors] = useState([
    {
      resource: "v1",
      start: '00:00',
      end: '24:00',
      recurring: {
        repeat: 'daily',
      },
      cssClass: 'md-rect-bg orange-bg',
    }
  ])
  const [tempEvent, setTempEvent] = useState(null);
  const [undoEvent, setUndoEvent] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const [start, startRef] = useState(null);
  const [end, endRef] = useState(null);
  const [popupEventTitle, setTitle] = useState('');
  const [popupEventCity, setCity] = useState('');
  const [popupEventTripNumber, setTripNumber] = useState('');
  const [popupEventActionCode, setActionCode] = useState('');
  const [popupEventDescription, setDescription] = useState('');
  const [popupEventAllDay, setAllDay] = useState(true);
  const [popupEventDate, setDate] = useState([]);
  const [popupEventStatus, setStatus] = useState('busy');
  const [mySelectedDate, setMySelectedDate] = useState(now);
  const [colorPickerOpen, setColorPickerOpen] = useState(false);
  const [colorAnchor, setColorAnchor] = useState(null);
  const [selectedColor, setSelectedColor] = useState('');
  const [tempColor, setTempColor] = useState('');
  const [isSnackbarOpen, setSnackbarOpen] = useState(false);
  const eventDialog = useRef();
  const colorPicker = useRef();
  const [tooltipAnchor, setTooltipAnchor] = useState(null);
  const [isTooltipOpen, setTooltipOpen] = useState(false);
  const timerRef = useRef(null);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [currentDraggedItems, setcurrentDraggedItems] = useState({});
  const [contextData, setContextData] = useState({});
  const [showTimelineContextMenu, setShowTimelineContextMenu] = useState(false);
  const [myConnections, setmyConnections] = useState([])
  const [agendaItemTypes, setAgendaItemTypes] = useState([
    { text: "Damage" },
    { text: "Doctor Visit" },
    { text: "Holiday" },
    { text: "Ill" },
    { text: "Inspection" },
    { text: "Leave" },
    { text: "Maintenance" },
    { text: "Repair" },
    { text: "Unused" },
  ])
  const [isShow, setFlagShow] = useState(false);
  const [expanded, setExpanded] = React.useState('panel1');
  const [startDate, setStartDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [mySelectedEvents, setSelectedEvents] = useState([]);
  const [selectedValue, setSelected] = useState(false);
  const [days, setDays] = useState(3);
  const [showWeekNumber, setShowWeekNumber] = useState(false);
  const [showCurrentTimeline, setCurrentTimeline] = useState(true);
  const [showVerticleLine, setShowVerticleLine] = useState(true);
  const [isShowToggleForConfig, setFlagShowToggleForConfig] = useState(false);
  const [iconActive, setIconSelected] = useState("truck");
  let timeLineView = {
    type: 'day',
    size: days,
    resolutionHorizontal: 'hour',
    // eventList: true,
    startTime: '00:00',
    endTime: '24:00',
    timeCellStep: 60,
    timeLabelStep: 60,
    weekNumbers: showWeekNumber,
    currentTimeIndicator: showCurrentTimeline,
    virtualScroll: true,
    resolution: 'day',
  };
  const [agendaKey, setagendaKey] = useState(1);
  const [myView, setMyView] = useState({
    timeline: timeLineView,
  });
  const prtFilterComponents = [
    { type: 'DateTimePicker', key: 'selectedDate', value: selectedDate, label: 'Selected date', placeholder: 'Selected date' },
    { type: 'NumericTextBox', key: 'daysToShow', value: days, label: 'Days to Show', placeholder: 'Please enter value' },
    { type: 'Switch', key: 'showWeekNumber', value: showWeekNumber, label: '', placeholder: 'Show Week' },
    { type: 'Switch', key: 'showCurrentTimeline', value: showCurrentTimeline, label: '', placeholder: 'Show Current Timeline' },
    { type: 'Switch', key: 'showVerticleLine', value: showVerticleLine, label: '', placeholder: 'Show Verticle Line' },
  ];
  const actionColorData = [
    { class: 'complate-trip', actionCode: LOAD, executedColor: "#BDE0BC", executingColor: "#91CC90", toBeExecutedColor: "#59AA57" },
    { class: 'complate-trip', actionCode: LOADDEPOT, executedColor: "#BDE0BC", executingColor: "#91CC90", toBeExecutedColor: "#59AA57" },
    { class: 'complate-trip', actionCode: UNLOAD, executedColor: "#FFCEBB", executingColor: "#FFB598", toBeExecutedColor: "#F39773" },
    { class: 'complate-trip', actionCode: UNLOADDEPOT, executedColor: "#FFCEBB", executingColor: "#FFB598", toBeExecutedColor: "#F39773" },
    { class: 'complate-trip', actionCode: PICKUP, executedColor: "#A0D4EA", executingColor: "#82CFF0", toBeExecutedColor: "#55BCE7" },
    { class: 'complate-trip', actionCode: DEPOSIT, executedColor: "#A0D4EA", executingColor: "#82CFF0", toBeExecutedColor: "#55BCE7" },
    { class: 'complate-trip', actionCode: COUPLE, executedColor: "#DFEAA0", executingColor: "#CCDC72", toBeExecutedColor: "#B3C839" },
    { class: 'complate-trip', actionCode: UNCOUPLE, executedColor: "#DFEAA0", executingColor: "#CCDC72", toBeExecutedColor: "#B3C839" },
    { class: 'complate-trip', actionCode: FERRYON, executedColor: "#A3BCFF", executingColor: "#95B2FF", toBeExecutedColor: "#7A9EFC" },
    { class: 'complate-trip', actionCode: FERRYOF, executedColor: "#A3BCFF", executingColor: "#95B2FF", toBeExecutedColor: "#7A9EFC" },
    { class: 'complate-trip', actionCode: CLEANING, executedColor: "#D2D0D2", executingColor: "#B9B3B9", toBeExecutedColor: "#ACA0AC" },
    { class: 'complate-trip', actionCode: BREAK, executedColor: "#DED1B0", executingColor: "#D2BA7C", toBeExecutedColor: "#C7A95E" },
    { class: 'complate-trip', actionCode: DRIVE, executedColor: "#CFCFF5", executingColor: "#ADADEF", toBeExecutedColor: "#8888E5" },
  ]
  const toDayDate = new Date();
  const minDate = new Date(toDayDate.getFullYear() - 50, toDayDate.getMonth(), toDayDate.getDate());
  const maxDate = new Date(toDayDate.getFullYear() + 50, toDayDate.getMonth(), toDayDate.getDate());
  const timelineRef = useRef(null);
  const offSet = useRef({
    left: 0,
    top: 0,
  });
  const currentAgendaItem = useRef("")
  const [contextMenuItems, setContextMenuItems] = useState([]);
  // const contextMenuItems = useRef([])
  //   let currentDraggedItems = {}
  const dispatch = useDispatch();
  // const schedulerTray = useSelector(state => state.schedulerTray);
  const drageItems = useSelector(state => state.drag);

  // const [state, setState] = useState({
  //   tasks: schedulerTray.tasks,
  //   appointments: defaultAppointments,
  // });
  // useEffect(() => {
  //   setState({ tasks: [...schedulerTray.tasks] })
  // }, [schedulerTray])

  //   const myView = useMemo(() => ({ timeline: { labels: true } }), []);
  // const handleEventCreate = useCallback(
  //   (args) => {
  //     setState((currentState) => {
  //       let { tasks } = currentState;
  //       tasks = tasks.filter((item) => item.id !== args.event.id)

  //       dispatch(setSchedulerTrayReducer(tasks))
  //       return { tasks: [...tasks] };
  //     });
  //     setTasks();
  //     setToastMessage(args.event.title + ' added');
  //     setToastOpen(true);
  //   },
  //   [state.tasks],
  // );

  const handleEventDelete = useCallback((args) => {
    setToastMessage(args.event.title + ' unscheduled');
    setToastOpen(true);
  }, []);

  // const handleItemDrop = useCallback((args) => {
  //   if (args.data) {
  //     setState((currentState) => {
  //       const { tasks } = currentState;
  //       // const index = tasks.indexOf(e.fromData);
  //       // if (index >= 0) {
  //       //   tasks.splice(index, 1);          
  //       tasks.push(args.data);
  //       // }
  //       dispatch(setSchedulerTrayReducer(tasks));
  //       return { tasks: [...tasks] };
  //     });
  //   }
  // }, []);

  const handleToastClose = useCallback(() => {
    setToastOpen(false);
  }, []);

  //   useEffect(() => {
  //     getJson(
  //       'https://trial.mobiscroll.com/drag-drop-events/',
  //       (events) => {
  //         setMyEvents(events);
  //       },
  //       'jsonp',
  //     );
  //   }, []);
  const colorButtons = useMemo(
    () => [
      'cancel',
      {
        text: 'Set',
        keyCode: 'enter',
        handler: () => {
          setSelectedColor(tempColor);
          setColorPickerOpen(false);
        },
        cssClass: 'mbsc-popup-button-primary',
      },
    ],
    [tempColor],
  );

  const colorResponsive = useMemo(
    () => ({
      medium: {
        display: 'anchored',
        touchUi: false,
        buttons: [],
      },
    }),
    [],
  );

  const snackbarButton = useMemo(
    () => ({
      action: () => {
        // setMyEvents((prevEvents) => [...prevEvents, undoEvent]);
      },
      text: 'Undo',
    }),
    [undoEvent],
  );

  const handleSnackbarClose = useCallback(() => {
    setSnackbarOpen(false);
  }, []);

  const saveEvent = useCallback(() => {
    const newEvent = {
      id: isEdit ? tempEvent.id : guid(),
      title: popupEventTitle,
      description: popupEventDescription,
      tripNo: popupEventTripNumber,
      actionCode: popupEventActionCode,
      start: popupEventDate[0],
      end: tempEvent.isRemark?new Date(popupEventDate[0]).setHours(new Date(popupEventDate[0]).getHours()+1):popupEventDate[1],
      allDay: popupEventAllDay,
      status: popupEventStatus,
      color: tempEvent.color,
      resource: tempEvent.resource,
      startAddressCity: tempEvent.startAddressCity,
      endAddressCity: tempEvent.endAddressCity,
      endAction: tempEvent.endAction,
      startAction: tempEvent.startAction,
      isRemark: tempEvent.isRemark,
      isAgendaItem: tempEvent.isAgendaItem,
      actions: tempEvent.actions,
      agendaItemType: currentAgendaItem.current,
      city: popupEventCity,
      shortCity: popupEventCity?.substring(0, 3) || tempEvent.shortCity,
      shortCity: popupEventCity?.substring(0, 3) || tempEvent.shortCity,
      addresscode: tempEvent.addresscode,
      addressname: tempEvent.addressname,
      address: tempEvent.address,
      postCode: tempEvent.postCode,
      //color: selectedColor,
    };
    if (newEvent.isRemark) {
      newEvent.dragToResize = false
      newEvent.dragInTime = false
      newEvent.dragBetweenResources = false
      newEvent.resize = false
      // newEvent.end = newEvent.start.
    } else if (newEvent.isAgendaItem) {
      newEvent.dragToResize = false
      newEvent.dragInTime = false
      newEvent.dragBetweenResources = false
      newEvent.resize = false
      newEvent.overlap = false
    }
    // console.log("saveEvent", newEvent)
    if (isEdit) {
      // update the event in the list
      const index = myEvents.findIndex((x) => x.id === tempEvent.id);
      const newEventList = [...myEvents];

      newEventList.splice(index, 1, newEvent);
      setMyEvents(newEventList);
      // here you can update the event in your storage as well
      // ...
    } else {
      // add the new event to the list
      setMyEvents([...myEvents, newEvent]);
      // here you can add the event to your storage as well
      // ...
    }
    // console.log(myEvents)
    setMySelectedDate(popupEventDate[0]);
    // close the popup
    currentAgendaItem.current = ""
    setOpen(false);
  }, [isEdit, myEvents, popupEventAllDay, popupEventDate, popupEventDescription, popupEventTripNumber, popupEventActionCode, popupEventStatus, popupEventTitle, popupEventCity, tempEvent]);

  useEffect(() => {
    parseEventData("Action")
  }, [myEvents])
  const deleteEvent = useCallback(
    (event) => {
      setMyEvents(myEvents.filter((item) => item.id !== event.id));
      setUndoEvent(event);
      // setTimeout(() => {
      //   setSnackbarOpen(true);
      // });
    },
    [myEvents],
  );

  const loadPopupForm = useCallback((event) => {
    setTitle(event.title);
    setTripNumber(event.tripNo);
    setActionCode(event.actionCode);
    setCity(event.city);
    setDescription(event.description);
    setDate([event.start, event.end]);
    setAllDay(event.allDay || false);
    setStatus(event.status || 'busy');
    setSelectedColor(event.color || '');
  }, []);

  // handle popup form changes

  const titleChange = useCallback((ev) => {
    setTitle(ev.target.value);
  }, []);
  const tripNumberChange = useCallback((ev) => {
    setTripNumber(ev.target.value);
  }, []);
  const actionCodeChange = useCallback((ev) => {
    setActionCode(ev.target.value);
  }, []);
  const actionCityChange = useCallback((ev) => {
    setCity(ev.target.value);
  }, []);

  const descriptionChange = useCallback((ev) => {
    setDescription(ev.target.value);
  }, []);

  const allDayChange = useCallback((ev) => {
    setAllDay(ev.target.checked);
  }, []);

  const dateChange = useCallback((args) => {
    setDate(args.value);
  }, []);

  const statusChange = useCallback((ev) => {
    setStatus(ev.target.value);
  }, []);

  const onDeleteClick = useCallback(() => {
    deleteEvent(tempEvent);
    currentAgendaItem.current = ""
    setOpen(false);
  }, [deleteEvent, tempEvent]);

  // scheduler options

  const onSelectedDateChange = useCallback((event) => {
    setMySelectedDate(event.date);
  }, []);

  const onEventClick = useCallback(
    (args) => {
      console.log(args)
      if((args.domEvent.ctrlKey || args.domEvent.shiftKey)){
        // if(mySelectedEvents.includes())
      }else{
        setEdit(true);
        setTempEvent({ ...args.event });
        // fill popup form with event data
        loadPopupForm(args.event);
        setAnchor(args.domEvent.target);
        if (args.event.isAgendaItem)
          currentAgendaItem.current = args.event.agendaItemType
        setOpen(true);
      }      
    },
    [loadPopupForm],
  );

  const onEventCreated = useCallback(
    (args) => {
      // createNewEvent(args.event, args.target)
      setEdit(false);
      setTempEvent(args.event);
      // fill popup form with event data
      loadPopupForm(args.event);
      setAnchor(args?.target);
      // open the popup
      setOpen(true);
    },
    [loadPopupForm],
  );

  const onEventDeleted = useCallback(
    (args) => {
      deleteEvent(args.event);
    },
    [deleteEvent],
  );

  const onEventUpdated = useCallback(() => {
    // here you can update the event in your storage as well, after drag & drop or resize
    // ...
  }, []);

  // datepicker options
  const controls = useMemo(() => (popupEventAllDay ? ['date'] : ['datetime']), [popupEventAllDay]);
  const datepickerResponsive = useMemo(
    () =>
      popupEventAllDay
        ? {
          medium: {
            controls: ['calendar'],
            touchUi: false,
          },
        }
        : {
          medium: {
            controls: ['calendar', 'time'],
            touchUi: false,
          },
        },
    [popupEventAllDay],
  );

  // popup options
  const headerText = useMemo(() => (isEdit ? 'Edit event' : 'New Event'), [isEdit]);
  const popupButtons = useMemo(() => {
    if (isEdit) {
      return [
        'cancel',
        {
          handler: () => {
            saveEvent();
          },
          keyCode: 'enter',
          text: 'Save',
          cssClass: 'mbsc-popup-button-primary',
        },
      ];
    } else {
      return [
        'cancel',
        {
          handler: () => {
            saveEvent();
          },
          keyCode: 'enter',
          text: 'Add',
          cssClass: 'mbsc-popup-button-primary',
        },
      ];
    }
  }, [isEdit, saveEvent]);

  const popupResponsive = useMemo(
    () => ({
      medium: {
        display: 'center',
        width: 400,
        fullScreen: false,
        touchUi: false,
      },
    }),
    [],
  );

  const onClose = useCallback(() => {
    if (!isEdit) {
      // refresh the list, if add popup was canceled, to remove the temporary event
      //   setMyEvents([...myEvents]);
    }
    setOpen(false);
  }, [isEdit, myEvents]);

    
  const handleSelectedEventsChange = (args) => {
    console.log("selected events",args)
    setSelectedEvents(args.events);
  }
  useEffect(()=>{
    console.log("useEffect slected events",mySelectedEvents)
  },[mySelectedEvents])
  useEffect(()=>{
    console.log("useEffect slected events",myEvents)
  },[myEvents])
  


  const renderMySlot = useCallback((args) => {
    const slotId = args.slot.id;
    return (
      <div style={{ backgroundColor: '#a5ceff4d', padding: '4px' }}>
        <div className="slot-name">{args.slot.name}</div>
      </div>
    );
  }, []);
  useEffect(() => {
    setcurrentDraggedItems(drageItems)
  }, [drageItems])

  const onResourceDrop = (e, resource, dragData) => {
    // setTimeout(() => {                   
    if (currentDraggedItems.source == 'partialTrips') {
      currentDraggedItems.items.forEach(e => {
        let id = myEvents.length + 1
        const startDate = moment(`${e?.startingDate?.toLocaleDateString()} ${e?.startTime}`, 'MM/DD/YYYY HH:mm:ss').format()
        const endDate = moment(`${e?.endingDate?.toLocaleDateString()} ${e?.endTime}`, 'MM/DD/YYYY HH:mm:ss').format()
        onEventCreated({
          event: {
            id: guid(),
            title: e.tripNo,
            start: new Date(now).setHours(1, 0, 0, 0),
            end: new Date(now.setHours(24, 0, 0, 0)),
            allDay: false,
            resource: resource.id,
            status: "busy",
          },
        });
        // }
      })
    }
    else if (currentDraggedItems.source == 'movements') {
      currentDraggedItems.items.forEach(e => {

        const startEvent = {
          id: guid(),
          title: e.shipmentNo,
          start: now.setHours(1, 0, 0, 0),
          end: now.setHours(4, 0, 0, 0),
          resource: resource.id,
          status: "busy",
          tripNo: e.shipmentNo,
          actionCode: e.startAction,
          city: e.startAddressCity,
          shortCity: e.startAddressCity?.substring(0, 3),
        }
        const endEvent = {
          id: guid(),
          title: e.shipmentNo,
          start: now.setHours(9, 0, 0, 0),
          end: now.setHours(12, 0, 0, 0),
          resource: resource.id,
          status: "busy",
          tripNo: e.shipmentNo,
          actionCode: e.endAction,
          city: e.endAddressCity,
          shortCity: e.endAddressCity?.substring(0, 3),
        }
        let tmpEvents = myEvents
        tmpEvents.push(startEvent)
        tmpEvents.push(endEvent)
        setMyEvents([...tmpEvents])
        parseEventData("Action")

        setToastOpen(true)
        setToastMessage(e.shipmentNo + " dropped successfully!")
      })
    }
    // }, 1000);
    resetDragEvent()
  }
  useEffect(() => {
    // console.log(myEvents)
  }, [])
  const [openMail, setOpenMail] = useState({ resource: "", isOpened: false });
  const toggleOpenMail = (data) => {
    if (data.isOpened) {
      setToastOpen(true)
      setToastMessage("Mail opened for " + data.resource)
    }
    setOpenMail(data);
  };
  const renderCustomResource = (resource) => {    
    return (
      <>
        {!resource.isParent && <div className="md-resource-header-template-cont d-flex" key={resource.id} name={`resource-row-${resource.id}`} style={{ height: '100%', width: '100%', }} onDragOver={(e) => { e.preventDefault(); }}
          onDrop={(e) => onResourceDrop(e, resource, drageItems)} onContextMenu={e => onCellRightClick(e, resource)}>

          <div className="list-col d-flex align-items-center">
            <div className='trucklogo' style={{ justifyContent: 'left', marginRight: '5px' }} >
              <div className='d-flex flex-row'>
                {iconActive == 'truck' && <>
                  <div className='d-flex cursor-pointer relative align-items-center' >
                    <span onMouseEnter={e => handleEventHoverIn(e, "TruckHover", resource)} onMouseLeave={handleEventHoverOut}>
                      {resource.id[0] == "v" && <BoxedTruck12Ton2Axles height="25" />}
                      {resource.id[0] == "s" && <EuropeanTruck height="25" />}
                      {/* {resource.vehicleBrand == "volvo" && <BoxedTruck12Ton2Axles height="30" />} */}
                      {resource.id[0] == "t" && <FlatbedTruck height="25" />}
                    </span>
                  </div>
                  {/* <div className='dyd'></div> */}
                </>}
                {iconActive == 'trailer' && <>
                  {/* onMouseEnter={e => handleEventHoverIn(e, "TrailerHover", resource)} onMouseLeave={handleEventHoverOut} */}
                  <div className='d-flex align-items-center relative ' style={{ gap: '5px' }} >
                    {resource.id[0] == "v" && <>
                        {(resource.id == "v7" || resource.id == "v9")?
                        <Semitrailer2 height="30" width="60" />:<BoxTrailer  height="30" width="60" />}
                      </>}
                    {resource.id[0] == "s" && <TankTrailer height="35" width="70" />}
                    {resource.id[0] == "t" && <ChassisTrailer height="35" width="70" />}
                    {/* {resource.vehicleBrand == "volvo" && <ChassisTrailer height="30" width="50" />} */}
                    <div className='resource-number'>
                      T00{resource.id.toUpperCase()}
                    </div>

                    <div className='qualifications-block'>
                      <Tooltip title="Open Roof"><span><OpenRoof height="20" /></span></Tooltip>
                      <Tooltip title="Roaler Bed"><span><RoalerBed height="20" /></span></Tooltip>
                      {(resource.id[0] != "s" && resource.id[0] != "t") && <Tooltip title="Tail Lift"><span><TailLift height="20" /></span></Tooltip>}
                      <Tooltip title="Temperature Control"><span><TemperatureHigh height="20" /></span></Tooltip>
                      {/* <TemperatureLow height="20" /> */}
                      {/* <TrailerAcxle height="20" /> */}
                      {(resource.id[0] != "s") &&<Tooltip title="Mounted Forklift"><span><MountedForklift height="20" /></span></Tooltip>}
                    </div>

                  </div>

                </>}
                <div className='d-flex mt0'>
                  <div onMouseEnter={e => handleEventHoverIn(e, "LicenseHover", resource)} onMouseLeave={handleEventHoverOut}>
                    <Tooltip width="600" title={resource.countryCode.toUpperCase()}>
                      {iconActive == 'trailer' && <span className={'number-plate sm ' + resource.countryCode} draggable onDragStart={e => handleDragStart(e, "Resource")}>
                        {iconActive == 'trailer' && resource.trailerLicencePlate}
                      </span>}
                      {iconActive == 'truck' && <span className={'number-plate sm ' + resource.countryCode} draggable onDragStart={e => handleDragStart(e, "Resource")}>
                        {iconActive == 'truck' && resource.name}
                      </span>}
                    </Tooltip>
                  </div>


                  {iconActive == 'driver' && <div className='driver-logo'>
                    <div className='d-flex cursor-pointer relative'>
                      <div style={{ backgroundColor: '#e3f0f8', marginRight: '10px', borderRadius: '5px' }}>
                        {resource.driverName && <img src={resource.imgPath} style={{ borderRadius: '4px', height: '50px', verticalAlign: 'middle', }} alt="user" />}
                      </div>
                      {/* {resource.vehicleBrand == "toyota" && <div style={{ backgroundColor: '#e3f0f8', marginRight: '10px', borderRadius: '5px' }}>
                        <img src={usrImg1} style={{ borderRadius: '4px', height: '50px', verticalAlign: 'middle', }} alt="user" />
                      </div>}
                      {resource.vehicleBrand == "volvo" && <div style={{ backgroundColor: '#e3f0f8', marginRight: '10px', borderRadius: '5px' }}>
                        <img src={usrImg2} style={{ borderRadius: '4px', height: '50px', verticalAlign: 'middle', }} alt="user" />
                      </div>} */}
                      {/* <div className='capacity-trailer' style={{width:'40%'}}>
                    40%
                  </div> */}
                      <span style={{ fontWeight: '600', display: 'flex', alignItems: 'center', minWidth: '98px' }}>{resource?.driverName?.replace('-',' ')} </span>
                    </div>

                  </div>}


                  <div style={{ margin: "0 5px", display: 'flex', gap: 3, alignItems: 'center' }} >
                    <i className="icon" style={{ height: '20px' }} >
                      {openMail.resource == resource.name && openMail.isOpened ? <CommentIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: false })} /> : <MarkUnreadChatAltIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: true })} />}
                    </i>

                    <WarningIcon color='warning' fontSize="small" />

                  </div>
                </div>

              </div>



            </div>
            {/* <div className='trucklogo' style={{justifyContent:'end',}}>
                   
            </div> */}
            {/* <div className='brandlogo'>
              {resource.vehicleBrand == "bmw" && <BmwLogo />}
              {resource.vehicleBrand == "toyota" && <ToyotaLogo />}
              {resource.vehicleBrand == "volvo" && <VolvoLogo />}
            </div> */}

            {/* <div className='separator-line d-flex align-items-center ml-auto'>
               
              <span style={{ margin: "0 5px", display: 'flex', gap: 3, alignItems: 'center' }} >
                <i className="icon" style={{ height: '20px' }} >
                  {openMail.resource == resource.name && openMail.isOpened ? <CommentIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: false })} /> : <MarkUnreadChatAltIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: true })} />}
                </i>
                 
                <WarningIcon color='warning' fontSize="small" />
                 
              </span>


            </div> */}
            <span className='list-checkbox ml-auto pnl-checkbox'>
              <Checkbox key={resource.id} />
            </span>
          </div>

        </div>}
        {resource.isParent && <> <span>{resource.name}</span>
        </>}
      </>
    )
  }
  const renderCell = (date, resources, events) => {
    return (
        <div
            key={`${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`}
            id={`resource-row-${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`}
            className="mbsc-timeline-cell"
        >
            {date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </div>
    );
};
  const findResourceById = (id) => {
    for (const category of myResources) {
      for (const resource of category.children) {
        if (resource.id === id) {
          return resource;
        }
      }
    }
    return null; // If resource with the given ID is not found
  };

  const handleEventHoverIn = useCallback((args, popupType, resourceData) => {
    const event = args.event || args;
    event.popupType = popupType
    if (!resourceData)
      event.resourceData = findResourceById(event.resource) 
    else
      event.resourceData = resourceData
    let totalResCapacity = event.resourceData?.capacityInKg
    const sumOfWeight = myEvents
      ?.filter(action => (action.actionCode == LOAD || action.actionCode == LOADDEPOT) && action.tripNo == event.tripNo) // Filter LOAD actions
      ?.map(action => action.weight || 400) // Extract weight, use 400 if weight is undefined
      ?.reduce((acc, weight) => acc + weight, 0);    
    event.resCapicity = Math.round((sumOfWeight * 100) / totalResCapacity) || 50
    setCurrentEvent(event);
    setTooltipAnchor(args?.target || args?.domEvent?.target);
    setTooltipOpen(true);
  }, []);

  const handleEventHoverOut = useCallback(() => {
    timerRef.current = setTimeout(() => {
      setTooltipOpen(false);
    }, 200);
  }, []);

  const handleEventClick = useCallback(() => {
    setTooltipOpen(true);
  }, []);

  const onMouseEnter = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);

  const onMouseLeave = useCallback(() => {
    timerRef.current = setTimeout(() => {
      setTooltipOpen(false);
    }, 200);
  }, []);

  // const pushEventToTray = useCallback((args) => {
  //   if (args) {
  //     setState((currentState) => {
  //       const { tasks } = currentState;
  //       args.id = guid()
  //       tasks.push(args);
  //       dispatch(setSchedulerTrayReducer(tasks));
  //       return { tasks: [...tasks] };
  //     });
  //   }
  // }, []);

  function shuffleChildren(array) {
    for (let i = 0; i < array.length; i++) {
      const children = array[i].children;
      for (let j = children.length - 1; j > 0; j--) {
        const k = Math.floor(Math.random() * (j + 1));
        [children[j], children[k]] = [children[k], children[j]];
      }
    }
    console.log(array)
  }
  const onCustomBtnClick = (value) => {
    setIconSelected(value)
    if (value == "truck") {
      setMyResources(msTruckResourceData);
      document.querySelectorAll('.mbsc-timeline-resource-col').forEach(item => {
        item.style.cssText = item.style.cssText + 'width: 180px !important; min-width:180px !important; resize:vertical !important';
      })
    } else if (value == "trailer") {
      setMyResources(msTruckResourceData);
      // shuffleChildren(msTruckResourceData)
      document.querySelectorAll('.mbsc-timeline-resource-col').forEach(item => {
        item.style.cssText = item.style.cssText + 'width: 250px !important; min-width:250px !important; resize:vertical !important';
      })
      setMyResources(msTrailerResourceData);
    } else if (value == "driver") {
      setMyResources(msDriverResourceData);
      // shuffleChildren(msTruckResourceData)
      document.querySelectorAll('.mbsc-timeline-resource-col').forEach(item => {
        item.style.cssText = item.style.cssText + 'width: 250px !important; min-width:280px !important; resize:vertical !important';
      })
    }
    parseEventData("Action")
  }
  const CustomButtons = (prop) => {
    return (
      <>
        <div className='my-buttons' style={{ position: 'absolute', display: 'flex', gap: 2, left: 0, zIndex: 10, top: '3px', paddingLeft: '0' }}>
          <Tooltip title='Truck'>
            <Button variant={iconActive === 'truck' ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} onClick={(e) => { onCustomBtnClick("truck"); }}>
              {iconActive === 'truck' ? <IconTruckWh /> : <IconTruck />}
            </Button>
          </Tooltip>
          <Tooltip title='Trailer'>
            <Button variant={iconActive === 'trailer' ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} onClick={(e) => { onCustomBtnClick("trailer"); }}>
              {iconActive === 'trailer' ? <TrailerIcon /> : <TrailerBlIcon />}
            </Button>
          </Tooltip>
          <Tooltip title='Driver'>
            <Button variant={iconActive === 'driver' ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} onClick={(e) => { onCustomBtnClick("driver"); }}>
              {iconActive === 'driver' ? <AccountCircleIcon sx={{ color: 'white' }} /> : <AccountCircleIcon color="primary" />}
            </Button>
          </Tooltip>
          <Tooltip title='Container'>
            <Button variant={iconActive === 'container' ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} >
              {iconActive === 'container' ? <ContainerIconWh /> : <ContainerIcon />}
            </Button>
          </Tooltip>
          <Tooltip title='Various Resource'>
            <Button variant={iconActive === 'variousResource' ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} >
              {iconActive === 'variousResource' ? <></> : <VariousResourceBlIcon />}
            </Button>
          </Tooltip>

        </div>

      </>
    )
  }
  const parseEventData = (flag) => {
    if (flag == "Trip") {
      var data = Object.groupBy(eventsData, ({ tripNo }) => tripNo)
      var groupedDataArray = [];
      for (const [key, value] of Object.entries(data)) {
        const endIndex = value.length - 1
        const [hours, minutes, seconds] = value[0].startingTime.split(":").map(Number);
        const [endHours, endMinutes, endSeconds] = value[endIndex].startingTime.split(":").map(Number);
        groupedDataArray.push({
          tripNo: key,
          data: value,
          start: new Date(value[0].startingDate).setHours(hours, minutes, seconds),
          end: new Date(value[endIndex].startingDate).setHours(endHours, endMinutes, endSeconds),
          resource: 1,
          id: guid()
        })
      }
      // console.log(groupedDataArray);
      setMyEvents(groupedDataArray)
    }
    else if (flag == "Action") {
      // console.log("setmyEvents(eventsData)",eventsData)
      let connection = []
      let tmpEvents = sortEventsByTripNo(myEvents.filter(e=> !e.isRemark && !e.isAgendaItem))
      tmpEvents.sort((a, b) => {
        // First, compare by tripNo
        if (a.tripNo < b.tripNo) return -1;
        if (a.tripNo > b.tripNo) return 1;

        // If tripNo is the same, compare by startingDate
        return a.start - b.start;
    });
    
    
      tmpEvents.forEach((curAction, i) => {        
        if (curAction?.tripNo == tmpEvents[i + 1]?.tripNo && curAction?.resource == tmpEvents[i + 1]?.resource)
          connection.push({
            from: curAction?.id,
            to: tmpEvents[i + 1]?.id,
            color: getConnectionColor(curAction?.actionCode),
            arrow: "",
            cssClass: curAction.actionCode == LOAD ? "dashed-line" : ''
          })
      })
      setmyConnections(connection)
      // setMyEvents(eventsData)
    }
  }
  const getConnectionColor = (action) => {
    if (action == LOAD)
      return "#FFCEBB"
    else if (action == UNLOAD)
      return "#FFCEBB"
    else if (action == LOADDEPOT)
      return "#FFCEBB"
    else if (action == UNLOADDEPOT)
      return "#FFCEBB"
    else if (action == PICKUP)
      return "#A0D4EA"
    else if (action == DEPOSIT)
      return "#A0D4EA"
    else if (action == COUPLE)
      return "#DFEAA0"
    else if (action == UNCOUPLE)
      return "#DFEAA0"
    else if (action == FERRYON)
      return "#A3BCFF"
    else if (action == FERRYOF)
      return "#A3BCFF"
    else if (action == CLEANING)
      return "#D2D0D2"
    else if (action == BREAK)
      return "#DED1B0"
    else if (action == DRIVE)
      return "#CFCFF5"
    else
      return "sandybrown"
  }
  function sortEventsByTripNo(events) {
    // Sort the events array based on the tripNo property
    events.sort((a, b) => {
      // Use localeCompare to ensure proper sorting for alphanumeric strings
      return a?.tripNo?.localeCompare(b.tripNo);
    });
    return events
  }
  const handleDragStart = (event, dragType) => {

    setTimeout(() => {
      const obj = {
        source: '',
        destination: '',
        eventType: '',
        isTripGenerated: false,
        items: { message: dragType + " dropped successfully!" }
      }
      // console.log("obj", obj)
      dispatch(drageItemsReducer(obj))
    }, 0);
  };
  const resetDragEvent = () => {
    const obj = {
      source: '',
      destination: '',
      eventType: '',
      isTripGenerated: false,
      items: {}
    }
    // console.log("obj", obj)
    dispatch(drageItemsReducer(obj))
  }
  const onCellRightClick = (event, inst) => {
    // console.log(event, inst)
    const isDomEvent = !!event?.domEvent;
    const left = isDomEvent ? event.domEvent.clientX : event.clientX;
    const top = isDomEvent ? event.domEvent.clientY : event.clientY;

    offSet.current = { left, top };

    const newContextMenuItems = isDomEvent
      ? ["Remark", "Agenda Item", "Instruction Without File"]
      : ["Send to OBC", inst.eventCreation == false ? "Enable Resource" : "Disable Resource"];

    setContextMenuItems(newContextMenuItems);
    setContextData({ event, inst });
    setShowTimelineContextMenu(true);
  }
  const onEventRightClick = (event, inst) => {
    console.log(event, inst)
    const isDomEvent = !!event?.domEvent;
    const left = isDomEvent ? event.domEvent.clientX : event.clientX;
    const top = isDomEvent ? event.domEvent.clientY : event.clientY;

    offSet.current = { left, top };
    const newContextMenuItems = []    
    if(mySelectedEvents.length == 2 && mySelectedEvents.some(e => e.id == event.event.id)){      
      newContextMenuItems.push("Change Sequence")
    }
    console.log(mySelectedEvents)
    console.log(event.event.id)
    // const newContextMenuItems = 
    // isDomEvent
    //   ? ["Remark", "Agenda Item", "Instruction Without File"]
    //   : ["Send to OBC", inst.eventCreation == false ? "Enable Resource" : "Disable Resource"];

    setContextMenuItems(newContextMenuItems);
    setContextData({ event, inst });
    setShowTimelineContextMenu(true);
  }
  const onCellContextClick = (e, Id, data) => {
    if (e == "remark") {
      const tmp = { isRemark: true, resource: contextData.event.resource }
      setEdit(false);
      setTempEvent(tmp);
      // fill popup form with event data
      loadPopupForm(tmp);
      setAnchor(contextData.event.target);
      setDate(contextData.event.date)
      // open the popup
      setOpen(true);
    }
    else if (e == 'disable-resource' || e == 'enable-resource') {
      findAndUpdateResource(myResources, contextData.inst.id, contextData.inst.depth)
    } else if (e == "agenda-item") {
      const tmp = { isAgendaItem: true, agendaItemType: "", resource: contextData.event.resource }
      const startDate = new Date(contextData.event.date)
      let endDate = new Date(startDate);
      endDate.setHours(endDate.getHours() + 2)
      setEdit(false);
      setTempEvent(tmp);
      // fill popup form with event data
      loadPopupForm(tmp);
      setAnchor(contextData.event.target);
      setDate([startDate, endDate])
      // open the popup
      setOpen(true);
    }else if(e == 'change-sequence'){
      swapSelectedEvents()
    }
    else {
      setToastMessage(e)
      setToastOpen(true);
      setSelectedEvents([])
    }
  }
  const swapSelectedEvents = ()=>{
    if(mySelectedEvents.length == 2){
      const index1 = myEvents.findIndex(event => event.id === mySelectedEvents[0].id)
      const index2 = myEvents.findIndex(event => event.id === mySelectedEvents[1].id)
  
      if (index1 === -1 || index2 === -1) {
        console.error('One or both events not found.');
        return;
      }
      const tempStart = myEvents[index1].start;
      const tempEnd = myEvents[index1].end;

      myEvents[index1].start = myEvents[index2].start;
      myEvents[index1].end = myEvents[index2].end;

      myEvents[index2].start = tempStart;
      myEvents[index2].end = tempEnd;

      setMyEvents([...myEvents])
      setSelectedEvents([])
    }
  }
  const findAndUpdateResource = (arr, id, depth) => {
    for (const item of arr) {
      if (item.id === id && depth === 0) {
        item.eventCreation = item.eventCreation == false ? true : false
        if (!item.eventCreation) {
          myColors.push({
            resource: id,
            start: '00:00',
            end: '24:00',
            recurring: {
              repeat: 'daily',
            },
            cssClass: 'md-rect-bg',
          })
          setMyColors([...myColors])
        } else {
          setMyColors([...removeCssClass(myColors, item.id, 'md-rect-bg')])
        }
        return true; // Return true if element is found and updated
      }
      else if (item.children && depth > 0) {
        const found = findAndUpdateResource(item.children, id, depth - 1);
        if (found) return true;
      }
    }
    // console.log(arr)
    setMyResources([...arr])
    return false;
  };

  const removeCssClass = (arr, resourceId, className) => {

    arr.forEach(item => {
      if (item.resource === resourceId && item.cssClass.includes(className)) {
        item.cssClass = item.cssClass?.replace(className, '').trim();
      }
    });
    return arr
  };
  React.useEffect(() => {
    document.addEventListener("click", (e) => {
      e.preventDefault();
      return showTimelineContextMenu ? setShowTimelineContextMenu(false) : null;
    });
  }, [showTimelineContextMenu]);

  useEffect(() => {
    parseEventData("Action")
  }, [])
  const onAgendaItemChange = (e) => {
    currentAgendaItem.current = e.value
  }
  const onCancelPopUp = (e) => {
    setOpen(false)
    currentAgendaItem.current = ""
  }
  const onWheel = (e) => {
    e.stopPropagation()
    if (e.deltaY < 0) {
      // console.log('scrolling up');
      myView.timeline.timeCellStep -= 30
      myView.timeline.timeLabelStep -= 30
      setMyView({ ...myView })
    }
    else if (e.deltaY > 0) {
      if (myView.timeline.timeCellStep <= 240) {
        myView.timeline.timeCellStep += 30
        myView.timeline.timeLabelStep += 30
      } else if (myView.timeline.type == 'week') {
        myView.timeline.type = 'month'
        myView.timeline.startDay = 0
        myView.timeline.endDay = 6
      }
      setMyView({ ...myView })
    }

  }

  const divRef = React.createRef()
  const preventDefault = e => e.preventDefault()

  // useEffect(() => {
  //   divRef.current?.addEventListener('wheel', preventDefault);

  //   // Remove event listener when the component unmounts
  //   return () => {
  //     divRef.current?.removeEventListener('wheel', preventDefault);
  //   };
  // }, [onWheel])
  const handleClick = () => {
    setFlagShow(!isShow);
  }
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const SaveViewsFilter = () => {
    // console.log('called save Views Filter');
  }
  const onChange =
    (key, value) => {            
      if (key === 'selectedDate') {
        value = new Date(value?.target?.value.value)
        if (value == 'Invalid Date' || (value < minDate) || (value > maxDate))
          return
        // callApi(IconActive, value)
        console.log(value)
        setSelectedDate(value)
      }
      else if (key === 'daysToShow' && value.value) {
        timeLineView.size = value.value;
        setDays(value.value)
        setMyView({ timeline: { ...timeLineView } })
      } else if (key == 'showWeekNumber') {
        timeLineView.weekNumbers = !showWeekNumber;
        setShowWeekNumber(!showWeekNumber)
        setMyView({ timeline: { ...timeLineView } })
      } else if (key == 'showCurrentTimeline') {
        timeLineView.currentTimeIndicator = !showCurrentTimeline;
        setCurrentTimeline(!showCurrentTimeline)
        setMyView({ timeline: { ...timeLineView } })      
      } else if (key == 'showVerticleLine') {        
        if (!showVerticleLine) {
          updateStyles('.mbsc-timeline-column.mbsc-ltr', 'border-right-style:solid !important;');
          updateStyles('.mbsc-timeline-day', 'position:relative;');
        } else {
          updateStyles('.mbsc-timeline-column.mbsc-ltr', 'border-right-style:none !important;');
          updateStyles('.mbsc-timeline-day-border', 'position:unset;');
        }        
        setShowVerticleLine(!showVerticleLine)
      }
    };
    const updateStyles = (selector, style) => {
      document.querySelectorAll(selector).forEach(item => {
        item.style.cssText += style;
      });
    };
    
  const onDateChange = (componentValue, e) => {
    if (event.type == 'click') {
      const obj = {
        type: "blur",
        target: { value: e }
      }
      onChange(componentValue.key, obj)
    }
  }
  const showToggleMenu = () => {
    setFlagShowToggleForConfig(!isShowToggleForConfig);
  }
  const getTrailerLicensePlate = (plt) => {
    return 'TRL' + plt?.slice(2)
  }
  const renderCustomHour = (args) => {
    return <div className={'md-date-header-hour '}>
      {formatDate('H:mm', args.date)}
    </div>
  }
  const renderCustomDay = useCallback((args) => {
    const date = args.date;
    return (
      <div className="header-template-container">
        <div className="header-template-date">
          <div className="header-template-day">{formatDate('DD-MM-YYYY', date)}</div>
        </div>
      </div>
    );
  }, []);
  const renderCustomMonth = useCallback((args) => {
    return (
      <></>
    );
  }, []);
  const getWindowHeight = ()=>{
    if(tempEvent.isRemark)
      return 260
    else if(tempEvent.isAgendaItem)
      return 400
    else  
      return 450
  }
  return (
    <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }}>
      <Box sx={{ p: 0, display: 'flex', }} className="filterbar-bg">
        {
          isShow &&
          <Grid item={true} component={Card} elevation={0} width={250} square className='overflow-datafix' sx={{ backgroundColor: 'info.light' }}>
            <CardContent sx={{ padding: 0 }}>
              <Box sx={{ flexGrow: 0, p: 1, backgroundColor: 'info.light', marginBottom: 0 }}>
                <div>
                  <Accordion className="mui-acc" sx={{ boxShadow: 0 }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="body2" sx={{ fontWeight: 'bold', paddingLeft: 0 }} color="primary" gutterBottom>My Views</Typography>
                      <IconButton aria-label="Save" color='primary' sx={{ padding: 0 }} onClick={SaveViewsFilter}>
                        <SaveIcon />
                      </IconButton>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: 0 }}>
                      <Box sx={{ flexGrow: 0, p: 0, backgroundColor: 'info.light', marginBottom: 1 }}>
                        <Stack spacing={1} sx={{}}>
                          {prtFilterComponents.map((component, index) => {
                            return (
                              <Box key={index} sx={{ justifyContent: 'center' }}>
                                <Typography variant="body2" sx={{ pr: 0 }}>{component.label} </Typography>
                                {component.type === 'DateTimePicker' && (
                                  <DateTimePicker
                                    showIcon
                                    selected={selectedDate}
                                    format={process.env.REACT_APP_DATETIMEFORMAT}
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    defaultValue={selectedDate}
                                    // onKeyDown={(value) => onChange(component.key, value)}
                                    // onBlur={(value) => onFilterComponentChange(component.key, value)}
                                    onChange={(value) => onDateChange(component, value)}
                                  />
                                )}
                                {component.type === 'NumericTextBox' && (
                                  <NumericTextBox
                                    placeholder={component.placeholder}
                                    format="n"
                                    min={2}
                                    max={7}
                                    autoComplete="off"
                                    value={days || 2}
                                    valid={component.value < 7}
                                    onChange={(value) => onChange(component.key, value)}
                                  // onBlur={(value) => onDayChange(component,value,event)}
                                  />
                                )}
                                {component.type === 'Switch' && (
                                  <span style={{ display: 'flex', justifyContent: 'space-between', margin: '3px 0px 5px 0px' }}>
                                    <Typography variant="body2">
                                      {component.placeholder}
                                    </Typography>
                                    <Checkbox
                                      // placeholder={component.placeholder}
                                      style={{ outlined: 0 }}
                                      // onLabel={""}
                                      // offLabel={""}
                                      // defaultChecked={component.value}
                                      checked={component.value}
                                      // onValueChange={(value) => onChange(component.key, value)}
                                      onClick={(event) => onChange(component.key, event.target.checked)}
                                    // onBlur={(value) => onDayChange(component,value,event)}
                                    />
                                  </span>
                                )}
                              </Box>
                            )
                          }
                          )}
                        </Stack>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </Box>
            </CardContent>
          </Grid>
        }
        <Grid item={true} elevation={0} sx={{ flexGrow: 0, pl: '0', alignItems: 'center' }}>
          <Box className="arrow-btn" onClick={handleClick}>
            {isShow ? <ArrowBackIosRoundedIcon color='secondary.contrastText' /> : <ArrowForwardIosRoundedIcon color='secondary.contrastText' />}
          </Box>
        </Grid>
        <Grid item xs={12} ref={divRef} square component={Card} elevation={0} sx={{ p: 0, width: '100%', position: 'relative' }} className="filterbar-bg " onContextMenu={(e) => { e.preventDefault() }}>
          <CustomButtons sx={{ p: 1, }} />

          <Box sx={{ p: 0, display: 'flex', }} className='grid-movement topfix-ms bootom-slider-fix'>
            
            <Eventcalendar
              key={agendaKey}
              ref={timelineRef}
              // locale={()=>{localeEn.timeWheels='HH:mm'; return localeEn}}
              timeFormat='HH:mm'
              data={myEvents}
              view={myView}
              startDate={startDate}
              colors={myColors}
              dragToMove={true}
              dragToCreate={true}
              externalDrop={true}
              externalDrag={true}
              dragToResize={true}
              clickToCreate="double"
              selectedDate={selectedDate}
              // renderHour={renderCustomHour}
              renderDay={renderCustomDay}
              // renderDayContent={()=> null}
              // onEventCreate={handleEventCreate}
              // onEventDelete={handleEventDelete}
              eventDelete={false}
              resources={myResources}
              // slots={[{
              //   id: 1,
              //   name: 'Morning',
              // }]}
              // renderSlot={renderMySlot}
              renderResource={renderCustomResource}
              onEventClick={onEventClick}
              onEventCreated={onEventCreated}
              onEventDeleted={onEventDeleted}
              onEventUpdated={onEventUpdated}
              showEventTooltip={false}
              onEventHoverIn={handleEventHoverIn}
              onEventHoverOut={handleEventHoverOut}
              renderScheduleEvent={(props)=> <CustomScheduleEvent data={props} myEvents={myEvents} iconActive={iconActive} />}
              // onResourceCollapse={(e) => console.log(e)}
              // onResourceExpand={(e) => console.log(e)}
              onCellRightClick={onCellRightClick}
              connections={myConnections}
              cssClass="md-timeline-height"
              groupBy="date"
              onEventDragEnd={(event, inst) => { parseEventData("Action") }}
              showControls={true}
              selectMultipleEvents={true}
              onSelectedEventsChange={handleSelectedEventsChange}
              selectedEvents={mySelectedEvents}
              onEventRightClick={onEventRightClick}
            />
          </Box>          
          {showTimelineContextMenu && <ContextMenu flag="scheduler" contextData={contextData} offset={offSet.current} data={contextMenuItems} sendToParent={onCellContextClick} />}
          {isOpen && <Window
            display="anchored"
            fullScreen={true}
            contentPadding={false}
            title={headerText}
            anchor={anchor}
            // buttons={popupButtons}
            open={isOpen}
            onClose={onClose}
            responsive={popupResponsive}
            className='hover-popup kendo-popup'
            ref={eventDialog}
            width={350}
            height={getWindowHeight()}
            style={{paddingBlock:'0px',paddingInline:'0px'}}
          >
            <Box sx={{ px: 1 }}>
                  <Box className="">

                  </Box>
                  {tempEvent?.isRemark ?
                    (<>
                      <Box className="mbsc-form-group textbox-group">
                        <Input label="Remark" value={popupEventTitle} onChange={titleChange} />
                        <Input ref={startRef} label="Time" className='dateicon' />
                        <Datepicker
                          select="range"
                          controls={controls}
                          touchUi={true}
                          startInput={start}
                          endInput={end}
                          showRangeLabels={false}
                          responsive={datepickerResponsive}
                          onChange={dateChange}
                          value={popupEventDate}
                        />
                        {/* <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '5px', marginTop: '0px' }}>
                          {isEdit ? (
                            <div className="" style={{ display: 'flex', gap: '5px' }} >
                              <Button className="" size="small" color="primary" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="contained" onClick={saveEvent}>
                                <SaveIcon fontSize="small" sx={{ marginRight: .5 }} /> Save
                              </Button>
                              <Button className="" size="small" color="danger" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="outlined" onClick={onDeleteClick}>
                                <Delete fontSize="small" sx={{ marginRight: .5 }} />  Delete
                              </Button>
                              <Button variant="outlined" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} onClick={(e) => setOpen(false)}>
                                <DoDisturbIcon fontSize="small" sx={{ marginRight: .5 }} />Cancel
                              </Button>
                            </div>
                          ) : (<div className="mbsc-button-group" style={{ display: 'flex', gap: '5px' }} >
                            <Button className="" size="small" color="primary" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="contained" onClick={saveEvent}>
                              <SaveIcon fontSize="small" sx={{ marginRight: .5 }} /> Save
                            </Button>
                            <Button variant="outlined" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} onClick={onDeleteClick}>
                              <DoDisturbIcon fontSize="small" sx={{ marginRight: .5 }} />Cancel
                            </Button>
                          </div>)}
                        </div> */}
                      </Box>
                    </>) :
                    (<>{tempEvent?.isAgendaItem ?
                      <>
                        <Box className="mbsc-form-group textbox-group">
                          <Input label="Reason" value={popupEventTitle} onChange={titleChange} />
                          <Box sx={{ paddingBottom: '2px', paddingLeft: '15px', paddingRight: '15px' }}>
                            <label style={{ fontSize: '14px' }}>Category</label>
                            <DropDownList
                              style={{
                                width: "100%",
                              }}
                              data={agendaItemTypes}
                              dataItemKey="text"
                              textField="text"                              
                              defaultItem={currentAgendaItem.current}
                              onChange={onAgendaItemChange}
                            />
                          </Box>
                          <Input ref={startRef} label="Time" className='dateicon' />
                          <Input ref={endRef} label="Ends" className='dateicon' />
                          <Datepicker
                            select="range"
                            controls={controls}
                            touchUi={true}
                            startInput={start}
                            endInput={end}
                            showRangeLabels={false}
                            responsive={datepickerResponsive}
                            onChange={dateChange}
                            value={popupEventDate}
                          />
                          {/* <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '5px', marginTop: '10px' }}>
                            {isEdit ? (
                              <div className="" style={{ display: 'flex', gap: '5px' }} >
                                <Button className="" size="small" color="primary" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="contained" onClick={saveEvent}>
                                  <SaveIcon fontSize="small" sx={{ marginRight: .5 }} /> Save
                                </Button>
                                <Button className="" size="small" color="danger" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="outlined" onClick={onDeleteClick}>
                                  <Delete fontSize="small" sx={{ marginRight: .5 }} />  Delete
                                </Button>
                                <Button variant="outlined" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} onClick={onCancelPopUp}>
                                  <DoDisturbIcon fontSize="small" sx={{ marginRight: .5 }} />Cancel
                                </Button>
                              </div>
                            ) : (<div className="mbsc-button-group" style={{ display: 'flex', gap: '5px' }} >
                              <Button className="" color="primary" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="contained" onClick={saveEvent}>
                                <SaveIcon fontSize="small" sx={{ marginRight: .5 }} /> Save
                              </Button>
                              <Button variant="outlined" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} onClick={onDeleteClick}>
                                <DoDisturbIcon fontSize="small" sx={{ marginRight: .5 }} onClick={onDeleteClick} />Cancel
                              </Button>
                            </div>)}
                          </div> */}
                        </Box>
                      </> :
                      <>
                        <Box className="mbsc-form-group textbox-group">
                          {/* <Input label="Title" value={popupEventTitle} onChange={titleChange} /> */}
                          <Input label="Trip Number" value={popupEventTripNumber} onChange={tripNumberChange} />
                          <Input label="Action Code" value={popupEventActionCode} onChange={actionCodeChange} />
                          <Input label="City" value={popupEventCity} onChange={actionCityChange} />
                          <Input ref={startRef} label="Time" className='dateicon' />
                          <Input ref={endRef} label="Ends" className='dateicon' />
                          <Datepicker
                            select="range"
                            controls={controls}
                            touchUi={true}
                            startInput={start}
                            endInput={end}
                            showRangeLabels={false}
                            responsive={datepickerResponsive}
                            onChange={dateChange}
                            value={popupEventDate}
                          />
                          {/* <div style={{ margin: '8px 15px 0px 15px' }}>
                            <SegmentedGroup onChange={statusChange}>
                              <Segmented value="busy" checked={popupEventStatus === 'busy'}>
                                Show as busy
                              </Segmented>
                              <Segmented value="free" checked={popupEventStatus === 'free'}>
                                Show as free
                              </Segmented>
                            </SegmentedGroup>
                          </div> */}
                          
                        </Box>
                      </>}</>)}
                </Box>
                <WindowActionsBar>
                    {tempEvent?.isRemark ?
                      (<> {isEdit ? (
                        <div className="" style={{ display: 'flex', gap: '5px' }} >
                          <Button className="" size="small" color="primary" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="contained" onClick={saveEvent}>
                            <SaveIcon fontSize="small" sx={{ marginRight: .5 }} /> Save
                          </Button>
                          <Button className="" size="small" color="danger" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="outlined" onClick={onDeleteClick}>
                            <Delete fontSize="small" sx={{ marginRight: .5 }} />  Delete
                          </Button>
                          <Button variant="outlined" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} onClick={(e) => setOpen(false)}>
                            <DoDisturbIcon fontSize="small" sx={{ marginRight: .5 }} />Cancel
                          </Button>
                        </div>
                      ) : (<div className="mbsc-button-group" style={{ display: 'flex', gap: '5px' }} >
                        <Button className="" size="small" color="primary" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="contained" onClick={saveEvent}>
                          <SaveIcon fontSize="small" sx={{ marginRight: .5 }} /> Save
                        </Button>
                        <Button variant="outlined" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} onClick={onDeleteClick}>
                          <DoDisturbIcon fontSize="small" sx={{ marginRight: .5 }} />Cancel
                        </Button>
                      </div>)}</>) :
                      (<>{tempEvent?.isAgendaItem ?
                        <>
                          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '5px', marginTop: '10px' }}>
                            {isEdit ? (
                              <div className="" style={{ display: 'flex', gap: '5px' }} >
                                <Button className="" size="small" color="primary" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="contained" onClick={saveEvent}>
                                  <SaveIcon fontSize="small" sx={{ marginRight: .5 }} /> Save
                                </Button>
                                <Button className="" size="small" color="danger" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="outlined" onClick={onDeleteClick}>
                                  <Delete fontSize="small" sx={{ marginRight: .5 }} />  Delete
                                </Button>
                                <Button variant="outlined" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} onClick={onCancelPopUp}>
                                  <DoDisturbIcon fontSize="small" sx={{ marginRight: .5 }} />Cancel
                                </Button>
                              </div>
                            ) : (<div className="mbsc-button-group" style={{ display: 'flex', gap: '5px' }} >
                              <Button className="" color="primary" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} variant="contained" onClick={saveEvent}>
                                <SaveIcon fontSize="small" sx={{ marginRight: .5 }} /> Save
                              </Button>
                              <Button variant="outlined" size="small" style={{ alignItems: 'center', display: 'flex', lineHeight: 'normal' }} onClick={onDeleteClick}>
                                <DoDisturbIcon fontSize="small" sx={{ marginRight: .5 }} onClick={onDeleteClick} />Cancel
                              </Button>
                            </div>)}
                          </div>
                        </> :
                        <>
                          <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 15px 0px 15px' }}>
                            {isEdit ? (
                              <div className="mbsc-button-group" >
                                <Button className="" size="small" color="primary" style={{ marginRight: '4px' }} variant="contained" onClick={saveEvent}>
                                  <SaveIcon fontSize="small" sx={{ marginRight: '5px' }} /> Save
                                </Button>
                                <Button className="" size="small" color="danger" style={{ marginRight: '4px' }} variant="outlined" onClick={onDeleteClick}>
                                  <Delete fontSize="small" sx={{ marginRight: '5px' }} />  Delete
                                </Button>
                                <Button variant="outlined" size="small" onClick={onCancelPopUp}>
                                  <DoDisturbIcon fontSize="small" sx={{ marginRight: '5px' }} />Cancel
                                </Button>
                              </div>
                            ) : (<div className="mbsc-button-group" >
                              <Button className="" size="small" color="primary" style={{ marginRight: '4px' }} variant="contained" onClick={saveEvent}>
                                <SaveIcon fontSize="small" sx={{ marginRight: '5px' }} /> Save
                              </Button>
                              <Button variant="outlined" size="small" onClick={onDeleteClick}>
                                <DoDisturbIcon fontSize="small" sx={{ marginRight: '5px' }} />Cancel
                              </Button>
                            </div>)}
                          </div>
                        </>}</>)}
                        
                </WindowActionsBar>
          </Window>}
          <Popup
            display="anchored"
            isOpen={isTooltipOpen}
            anchor={tooltipAnchor}
            touchUi={false}
            showOverlay={false}
            contentPadding={false}
            closeOnOverlayClick={false}
            //width={400}
            width={currentEvent?.popupType == "LicenseHover" ? 500 : 400}
            cssClass="md-tooltip"
          >
            <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
              <CustomAgendaTooltip currentEvent={currentEvent} iconActive={iconActive}/>
            </div>
          </Popup>
          <Snackbar isOpen={isSnackbarOpen} message="Event deleted" button={snackbarButton} onClose={handleSnackbarClose} />
          <AlertComponent isSuccessSnackbarOpen={isToastOpen} successSnackbarMessage={toastMessage} handleSuccessSnackbarClose={handleToastClose} />
          {/* <Toast message={toastMessage} isOpen={isToastOpen} onClose={handleToastClose} /> */}
        </Grid>
        <Box className='filterbar-bg disable-in-custom-view' sx={{ display: 'flex', }}>
          <Box className="arrow-btn" onClick={showToggleMenu}>
            {isShowToggleForConfig ? <ArrowForwardIosRoundedIcon color='secondary.contrastText' /> : <ArrowBackIosRoundedIcon color='secondary.contrastText' />}
          </Box>
          <Box className="overflow-datafix fix-heightMovement" sx={{ position: 'relative' }}>
            {isShowToggleForConfig &&
              <ToggleMenuForConfig gridFlagVal={""} gridSelectedDataAction={[]} gridSelectedPlanAction={[]} gridSelectedActions={[]} gridMenuItems={[]} griddefDataRelatedAction={[]} gridPlanMenuItems={[]} />
            }
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}

export default AgendaDemoMs;